import { Insertable } from 'kysely';
import { z } from '@harvestiq/zod';
import { dbAppSettingsSchema } from '../app-settings/db-app-settings';

export const orgAppSettingsSchema = dbAppSettingsSchema.extend({
  schemaName: z.string(),
  isCurrentOrg: z.boolean().optional(),
});

export type OrgAppSettings = z.infer<typeof orgAppSettingsSchema>;

export const allOrgAppSettingsResponseSchema = z.object({
  data: z.array(orgAppSettingsSchema),
});

export type AllOrgAppSettingsResponse = z.infer<
  typeof allOrgAppSettingsResponseSchema
>;

export type OrgAppSettingsInsert = Insertable<OrgAppSettings>;
